<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="
                    status != 'DRAFT' || isBackDateDataEntry != 'ACTIVE'
                  "
                >
                  <v-text-field
                    slot="activator"
                    label="IssueDate"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    readonly
                    :rules="rules.issueDateRules"
                  ></v-text-field>
                  <v-date-picker
                    v-model="issueDate"
                    :rules="rules.issueDateRules"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="stockIn.id">
                <v-text-field
                  name="issueNo"
                  label="Issue No."
                  v-model="stockIn.issueNo"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex :class="stockIn.id ? 'sm6' : 'sm12'">
                <v-text-field
                  name="serialNo"
                  label="GR No."
                  v-model="stockIn.serialNo"
                  type="text"
                  :rules="rules.serialNoRules(255, 'Serial No')"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="stockIn.warehouseName"
                  :items="activeWarehouseList"
                  color="blue-grey lighten-2"
                  label="Choose Warehouse..."
                  item-text="name"
                  menu-props="auto"
                  item-value="name"
                  @change="showBin(), changeWarehouse()"
                  :readonly="
                    status != 'DRAFT' ||
                      poNoSelected ||
                      user.role.roleName == 'WAREHOUSE_MANAGER' ||
                      user.role.roleName == 'WAREHOUSE_STAFF' ||
                      user.role.roleName == 'SALE_MANAGER' ||
                      user.role.roleName == 'GENERAL_MANAGER' ||
                      user.role.roleName == 'ASSET_MANAGER' ||
                      user.role.roleName == 'BRANCH_ADMIN' ||
                      user.role.roleName == 'PRODUCTION_MANAGER' ||
                      (user.role.roleName == 'PROCUREMENT_MANAGER' &&
                        user.warehouseId)
                  "
                  :rules="rules.warehouseRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="stockIn.binId"
                  :items="binList"
                  color="blue-grey lighten-2"
                  label="Choose Bin..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  :readonly="status != 'DRAFT'"
                  :rules="rules.warehouseRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-layout>
                  <v-flex sm10>
                    <v-text-field
                      name="poNo"
                      label="PO No"
                      v-model="stockIn.poNo"
                      type="text"
                      :readonly="status != 'DRAFT' || poNoSelected"
                      :rules="rules.poNoRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm>
                    <v-btn
                      outline
                      color="warning"
                      :disabled="status != 'DRAFT' || !isRegister"
                      @click="showPurchaseOrderDialog = true"
                    >
                      <v-icon dark>search</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  :readonly="status != 'DRAFT'"
                  v-model="stockIn.status"
                  :items="statusList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :rules="rules.statusRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  :readonly="status != 'DRAFT'"
                  v-model="stockIn.type"
                  :items="typeList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Type..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :rules="rules.typeRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="stockIn.description"
                  type="text"
                  :readonly="status != 'DRAFT'"
                  :rules="rules.descriptionRuless"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="stockIn.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="stockIn.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="stockIn.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="stockIn.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="stockIn.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="stockIn.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="showProductList()"
                    :disabled="status != 'DRAFT' || poNoSelected"
                  >
                    Add Item
                    <v-icon right>add</v-icon>
                  </v-btn>
                  <v-flex xs10 ml-4>
                    <v-text-field
                      name="scanBarcode"
                      label="Scan barcode....."
                      v-model="scanBarcode"
                      type="text"
                      :loading="barcodeLoading"
                      v-on:keyup.enter="trigger(scanBarcode)"
                      prepend-icon="filter_center_focus"
                      :disabled="status != 'DRAFT' || poNoSelected"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <!-- details table -->
                <v-card>
                  <v-card-title>
                    <v-flex xs4>
                      <v-text-field
                        v-model="detailCodeSearch"
                        append-icon="search"
                        placeholder="Enter product code/name"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-card-title>

                  <v-data-table
                    :headers="detailHeaders"
                    :items="detailList"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.productCode }}</td>
                      <td>{{ props.item.productName }}</td>
                      <td>{{ props.item.factorUnitName }}</td>
                      <td>{{ props.item.qty | decFormat(6) }}</td>
                      <td>{{ props.item.qcNo }}</td>
                      <td>{{ props.item.batchNo }}</td>
                      <td>
                        {{ props.item.mfgDateInMilliSeconds | formatMsDate }}
                      </td>
                      <td>
                        {{ props.item.expDateInMilliSeconds | formatMsDate }}
                      </td>
                      <td>{{ props.item.countryName }}</td>
                      <td>{{ props.item.supplierName }}</td>
                      <td>{{ props.item.remark }}</td>

                      <!-- actions -->
                      <td>
                        <v-layout>
                          <v-btn
                            flat
                            icon
                            color="blue lighten-2"
                            @click="editDetail(props.item)"
                            :disabled="status != 'DRAFT'"
                          >
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            @click="removeStockInItem(props.item.id)"
                            :disabled="status != 'DRAFT'"
                          >
                            <v-icon>cancel</v-icon>
                          </v-btn>
                        </v-layout>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="clear"
                    :disabled="stockIn.id ? true : false"
                  >
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :readonly="!valid"
                    @click="onSave"
                    :disabled="btnDisabled || saveLoading"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <v-dialog
      v-model="stockInItemDialog"
      scrollable
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title class="blue darken-3">
          <span class="title white--text">Stock In Item</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="detailForm" v-model="detailValid" lazy-validation>
            <v-layout row wrap>
              <v-flex xs4 pa-1>
                <v-text-field
                  name="productCode"
                  label="Product Code"
                  v-model="selectedStockInItem.productCode"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs8 pa-1>
                <v-text-field
                  name="productName"
                  label="Product Name"
                  v-model="selectedStockInItem.productName"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs4 pa-1>
                <v-autocomplete
                  v-model="selectedStockInItem.factorUnitName"
                  :hide-no-data="true"
                  :items="selectedStockInItem.productUnits"
                  color="blue-grey lighten-2"
                  label="Unit"
                  item-value="factorUnitName"
                  item-text="factorUnitName"
                  menu-props="auto"
                  @change="(option) => initPrice(option)"
                  :readonly="status != 'DRAFT'"
                  :rules="rules.unitRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs4 pa-1>
                <v-text-field
                  name="qty"
                  label="Qty"
                  v-model="selectedStockInItem.qty"
                  type="number"
                  min="0"
                  :rules="rules.geraterThanZeroQtyRules('Qty')"
                  :readonly="status != 'DRAFT'"
                ></v-text-field>
              </v-flex>
              <v-flex xs4 pa-1>
                <v-text-field
                  name="remainingQty"
                  label="Remaining Qty"
                  v-model="selectedStockInItem.remainingQty"
                  readonly
                  :disabled="!poNoSelected && !selectedStockInItem.qcNoSelected"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-layout>
                  <v-flex xs10>
                    <v-text-field
                      name="qcNo"
                      label="QC No"
                      v-model="selectedStockInItem.qcNo"
                      :readonly="selectedStockInItem.qcNoSelected"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm>
                    <v-btn
                      outline
                      color="warning"
                      :disabled="status != 'DRAFT'"
                      @click="showQCListDialog = true"
                    >
                      <v-icon dark>search</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field
                  name="batchNo"
                  label="Batch No"
                  v-model="selectedStockInItem.batchNo"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="
                    !selectedStockInItem.qcNo && !selectedStockInItem.batchNo
                  "
                >
                  <v-text-field
                    slot="activator"
                    label="MFG Date"
                    type="text"
                    prepend-icon="event"
                    v-model="selectedStockInItem.mfgDate"
                    readonly
                    :disabled="
                      !selectedStockInItem.qcNo && !selectedStockInItem.batchNo
                    "
                  ></v-text-field>
                  <v-date-picker
                    v-model="selectedStockInItem.mfgDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="
                    !selectedStockInItem.qcNo && !selectedStockInItem.batchNo
                  "
                >
                  <v-text-field
                    slot="activator"
                    label="EXP Date"
                    type="text"
                    prepend-icon="event"
                    v-model="selectedStockInItem.expDate"
                    readonly
                    :disabled="
                      !selectedStockInItem.qcNo && !selectedStockInItem.batchNo
                    "
                  ></v-text-field>
                  <v-date-picker
                    v-model="selectedStockInItem.expDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-autocomplete
                  v-if="status == 'DRAFT'"
                  v-model="selectedStockInItem.countryId"
                  :items="countryList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Country Of Origin..."
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  clearable
                ></v-autocomplete>
                <v-text-field
                  v-else
                  name="countryName"
                  label="Origin"
                  v-model="selectedStockInItem.countryName"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-autocomplete
                  v-model="selectedStockInItem.supplierId"
                  :items="supplierList"
                  color="blue-grey lighten-2"
                  label="Choose Supplier..."
                  item-text="companyName"
                  menu-props="auto"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 pa-1>
                <v-text-field
                  name="remark"
                  label="Remark"
                  v-model="selectedStockInItem.remark"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="closeStockInItemDialog">
                    Close
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="!detailValid"
                    @click="addStockInItem"
                  >
                    Add
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <PurchaseOrderListDialog
      :showDialog="showPurchaseOrderDialog"
      :params="{
        warehouseId: stockIn.warehouseId,
        isStockInRegisterFlag: true,
        isPOFinishedFlag: 'false',
        statuses: ['ပစ္စည်းရရှိပြီးQCစောင့်', 'ကုန်ပစ္စည်းရောက်ရှိမှု'],
        checkStockIn: true,
      }"
      @close="closePurchaseOrderDialog"
    ></PurchaseOrderListDialog>

    <ProductListDialog
      :showDialog="showProductListDialog"
      :params="{ isPurchase: true }"
      @close="closeProductDialog"
    ></ProductListDialog>

    <QCListDialog
      :showDialog="showQCListDialog"
      :params="{
        warehouseId: stockIn.warehouseId,
        productId: selectedStockInItem.productId,
        poNo: stockIn.poNo,
        isNoPurchaseOrder: !poNoSelected,
        status: 'PASS',
        checkStockIn: true,
      }"
      @close="closeQCListDialog"
    ></QCListDialog>

    <!-- final message dialog -->
    <v-dialog
      v-model="messageDialogBox"
      max-width="500px"
      @keydown.enter="messageDialogBox = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { warehouseService } from "../../services/warehouse-service";
import { supplierService } from "../../services/supplier-service";
import { productService } from "../../services/product-service";
import { stockInService } from "../../services/stockin-service";
import { commonService } from "../../services/common-service";
import { StockInItem } from "../../models/model";
import { StockIn } from "../../models/model";
import { StockInFormRules } from "../../helpers/validation-rules";
import PurchaseOrderListDialog from "../purchase-order/PurchaseOrderListDialog.vue";
import ProductListDialog from "../dialogs/ProductListDialog.vue";
import QCListDialog from "../qc/QCListDialog.vue";
import { countryService } from "../../services/country-service";

export default {
  name: "StockInDetail",
  components: {
    PurchaseOrderListDialog,
    ProductListDialog,
    QCListDialog,
  },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    isBackDateDataEntry: JSON.parse(
      localStorage.getItem("BACKDATE_DATA_ENTRY")
    ),
    valid: true,
    detailValid: true,
    breadcrumbs: [
      {
        text: "Stock In",
        disabled: false,
        to: "stockins",
      },
      {
        text: "Stock In Detail",
        disabled: true,
      },
    ],
    binList: [],
    createdDate: "",
    updatedDate: "",
    status: "DRAFT",
    issueDate: "",
    stockIn: new StockIn(),
    oldStockIn: new StockIn(),
    stockInItem: new StockInItem(),
    selectedStockInItem: new StockInItem(),
    rules: new StockInFormRules(),
    responseError: "",
    messageDialogBox: false,
    stockInItemDialog: false,
    saveLoading: false,
    isRegister: false,
    countryList: [],
    activeWarehouseList: [],
    tempList: [],
    supplierList: [],
    productUnitList: [],
    btnDisabled: false,
    statusList: [
      { label: "DRAFT", value: "DRAFT" },
      { label: "FINISHED", value: "FINISHED" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    typeList: [
      { label: "PURCHASING", value: "PURCHASING" },
      { label: "STORE_RETURN", value: "STORE_RETURN" },
      { label: "FOC", value: "FOC" },
      { label: "RENTAL", value: "RENTAL" },
      { label: "DONATION", value: "DONATION" },
      { label: "TRANSFER", value: "TRANSFER" },
      { label: "OPENING", value: "OPENING" },
      { label: "PRODUCTION", value: "PRODUCTION" },
    ],
    showProductListDialog: false,

    search: null,
    code: "",
    showListLoading: false,
    poNoSelected: false,
    selectedId: 0,

    purchaseOrderWarehouseList: [],
    showPurchaseOrderDialog: false,
    showQCListDialog: false,
    scanBarcode: "",
    barcodeLoading: false,

    detailHeaders: [
      { text: "Code", align: "left", value: "code", sortable: false },
      { text: "Product", align: "left", value: "name", sortable: false },
      { text: "Unit", align: "left", value: "factorUnit", sortable: false },
      { text: "Qty", align: "left", value: "qty", sortable: false },
      { text: "QC No", align: "left", value: "qcNo", sortable: false },
      { text: "Batch No", align: "left", value: "batchNo", sortable: false },
      { text: "MFG Date", align: "left", value: "mfgDate", sortable: false },
      { text: "EXP Date", align: "left", value: "expDate", sortable: false },
      { text: "Origin", align: "left", value: "countryId", sortable: false },
      { text: "Supplier", align: "left", value: "supplierId", sortable: false },
      { text: "Remark", align: "left", value: "remark", sortable: false },
      { text: "Action", value: "action", sortable: false },
    ],
    detailCodeSearch: "",
  }),

  computed: {
    detailList() {
      return this.stockIn.stockInItems.filter((d) => {
        if (this.detailCodeSearch)
          return (
            d.productCode
              .toLowerCase()
              .indexOf(this.detailCodeSearch.toLowerCase()) > -1 ||
            d.productName
              .toLowerCase()
              .indexOf(this.detailCodeSearch.toLowerCase()) > -1
          );
        else return true;
      });
    },
  },

  created() {
    this.getActiveWarehouseList();
    this.getAllSupplier();
    this.getActiveCountry();
    if (
      this.user.roleName == "WAREHOUSE_MANAGER" ||
      this.user.roleName == "WAREHOUSE_STAFF" ||
      this.user.roleName == "BRANCH_ADMIN"
    ) {
      this.stockIn.warehouseName = this.user.warehouseName;
      this.stockIn.warehouseId = this.user.warehouseId;
      if (this.user.roleName == "WAREHOUSE_STAFF") {
        this.binList = this.user.selectedBinList;
      }
    } else if (
      this.user.role.roleName == "SALE_MANAGER" ||
      this.user.role.roleName == "GENERAL_MANAGER" ||
      this.user.role.roleName == "PRODUCTION_MANAGER" ||
      this.user.role.roleName == "ASSET_MANAGER"
    ) {
      this.stockIn.warehouseName = this.user.shop.warehouseName;
      this.stockIn.warehouseId = this.user.shop.warehouseId;
    }
    const id = this.$route.params.id;
    if (id == "new") {
      this.isRegister = true;
      // new stockin
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substr(0, 10),
        "YYYY-MM-DD"
      );
    } else {
      this.getStockInDetail(id);
    }
  },

  methods: {
    getWarehouseList() {
      var temp;
      var tempWarehouseList = [];
      temp = this.stockIn.warehouse.name;
      if (!this.tempList.includes(temp)) {
        this.tempList.push(temp);
        tempWarehouseList.push(this.stockIn.warehouse);
      }

      for (var j = 0; j < this.activeWarehouseList.length; j++) {
        temp = this.activeWarehouseList[j].name;
        if (!this.tempList.includes(temp)) {
          this.tempList.push(temp);
          tempWarehouseList.push(this.activeWarehouseList[j]);
        }
      }
      this.activeWarehouseList = tempWarehouseList;
    },

    getActiveWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          let tempList = res.data;
          for (let temp of tempList) {
            this.activeWarehouseList.push(temp);
          }
          this.purchaseOrderWarehouseList = tempList;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.purchaseOrderWarehouseList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(findAll))
          );
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          let warehouseName = "";
          if (
            this.user.role.roleName == "SALE_MANAGER" ||
            this.user.role.roleName == "GENERAL_MANAGER" ||
            this.user.role.roleName == "PRODUCTION_MANAGER"||
            this.user.role.roleName == "ASSET_MANAGER"
          ) {
            warehouseName = this.user.shop.warehouseName;
          } else {
            warehouseName = this.user.warehouseName;
          }
          if (this.user.role.roleName != "WAREHOUSE_STAFF") {
            let warehouse = commonService.search(
              "name",
              warehouseName,
              this.activeWarehouseList
            );
            if (warehouse) {
              this.binList = warehouse.binList;
            }
          }
        });
    },
    getActiveCountry() {
      countryService
        .getCountryByStatus("ACTIVE")
        .then((res) => {
          this.countryList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllSupplier() {
      supplierService
        .getAllSupplier()
        .then((res) => {
          this.supplierList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goBack() {
      this.$router.go(-1);
    },

    generateId() {
      let duplicateFlag = true;
      let id;

      // generate random id until it's unique
      while (duplicateFlag) {
        id = Math.floor(Math.random() * 9999 + 1);

        // find if id is duplicated
        let duplicateDetail = this.stockIn.stockInItems.find((d) => d.id == id);
        if (!duplicateDetail) duplicateFlag = false;
      }
      return id;
    },

    getStockInDetail(id) {
      stockInService
        .getStockInDetail(id)
        .then((res) => {
          this.stockIn = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.stockIn.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.stockIn.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.poNoSelected = this.stockIn.poNoSelected;
          this.status = this.stockIn.status;
          if (
            this.status == "FINISHED" ||
            this.user.role.roleName == "PROCUREMENT_MANAGER"
          ) {
            this.btnDisabled = true;
          }
          this.issueDate = commonService.millisecondToDate(
            this.stockIn.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          if (this.user.roleName == "WAREHOUSE_STAFF") {
            this.binList = this.user.selectedBinList;
            let bin = this.binList.forEach((v) => v.id == res.data.binId);
            if (typeof bin == "undefined") {
              this.binList.push(res.data.bin);
            }
          } else {
            this.binList = res.data.warehouse.binList;
          }
          if (res.data.country) {
            this.countryList.push(res.data.country);
          }
          // deep copy
          this.oldStockIn = JSON.parse(JSON.stringify(res.data));
          this.getWarehouseList();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          //convert to millisecond
          this.stockIn.issueDateInMilliSeconds = commonService.convertToMilliseconds(
            this.issueDate
          );
          this.stockIn.isBackDateDataEntry = this.isBackDateDataEntry;

          // deep copy and remove detail id
          let stockIn = JSON.parse(JSON.stringify(this.stockIn));
          stockIn.warehouse = null;
          stockIn.stockInItems.forEach((detail) => {
            detail.productUnits = null;
            if (detail.isNew) detail.id = null;
          });

          stockInService
            .saveStockIn(stockIn)
            .then((res) => {
              if (res) {
                this.goBack();
              }
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
                this.messageDialogBox = true;
              }
              this.saveLoading = false;
            });
        }
      }
    },

    initPrice(factorUnitName) {
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.selectedStockInItem.productUnits
      );

      this.selectedStockInItem.productUnitId = productUnit.id;

      if (this.poNoSelected) {
        if (
          this.selectedStockInItem.basicUnitCost > 0 &&
          this.selectedStockInItem.poExchangeRate > 0
        ) {
          this.selectedStockInItem.unitCost = parseFloat(
            this.selectedStockInItem.basicUnitCost *
              productUnit.factor *
              this.selectedStockInItem.poExchangeRate
          );
          this.selectedStockInItem.poUnitCost = parseFloat(
            this.selectedStockInItem.basicUnitCost * productUnit.factor
          );
        }
      } else {
        this.selectedStockInItem.unitCost = productUnit.unitCost;
        this.selectedStockInItem.poUnitCost = productUnit.unitCost;
      }

      this.selectedStockInItem.sellingPrice = productUnit.sellingPrice;

      if (this.selectedStockInItem.remainingQty) {
        this.selectedStockInItem.remainingQty =
          (this.selectedStockInItem.remainingQty *
            this.selectedStockInItem.factor) /
          productUnit.factor;
        this.selectedStockInItem.factor = productUnit.factor;
      }
    },

    clear() {
      this.poNoSelected = false;
      this.$refs.form.resetValidation();
      if (!this.stockIn.id) {
        this.stockIn = new StockIn();
        this.stockIn.warehouseName = this.user.warehouseName;
      } else {
        this.stockIn = Object.assign({}, this.oldStockIn);
        this.stockIn.warehouseName = this.oldStockIn.warehouseName;
      }
    },

    showBin() {
      let warehouseName = this.stockIn.warehouseName;
      let warehouse = commonService.search(
        "name",
        warehouseName,
        this.activeWarehouseList
      );
      if (warehouse) {
        this.binList = warehouse.binList;
      }
    },

    closeStockInItemDialog() {
      this.stockInItemDialog = false;
    },

    addStockInItem() {
      if (this.$refs.detailForm.validate()) {
        // deep copy
        let stockInItem = JSON.parse(JSON.stringify(this.selectedStockInItem));
        if (stockInItem.mfgDate) {
          stockInItem.mfgDateInMilliSeconds = commonService.convertToMilliseconds(
            stockInItem.mfgDate
          );
        }
        if (stockInItem.expDate) {
          stockInItem.expDateInMilliSeconds = commonService.convertToMilliseconds(
            stockInItem.expDate
          );
        }
        if (!stockInItem.qcNo && !stockInItem.batchNo) {
          stockInItem.mfgDate = "";
          stockInItem.mfgDateInMilliSeconds = "";
          stockInItem.expDate = "";
          stockInItem.expDateInMilliSeconds = "";
        }
        let supplier = commonService.search(
          "id",
          this.selectedStockInItem.supplierId,
          this.supplierList
        );
        if (supplier) stockInItem.supplierName = supplier.companyName;

        if (stockInItem.countryId) {
          let country = this.countryList.find(
            (ct) => ct.id == stockInItem.countryId
          );
          if (country) {
            stockInItem.countryName = country.name;
          }
        } else {
          stockInItem.countryName = "";
        }

        const index = this.stockIn.stockInItems
          .map((d) => d.id)
          .indexOf(stockInItem.id);
        if (index > -1) {
          this.stockIn.stockInItems.splice(index, 1, stockInItem);
        } else {
          this.stockIn.stockInItems.unshift(stockInItem);
        }
        this.closeStockInItemDialog();
      }
    },

    removeStockInItem(stockInItemId) {
      const index = this.stockIn.stockInItems
        .map((d) => d.id)
        .indexOf(stockInItemId);

      if (!this.stockIn.stockInItems[index].isNew) {
        // add delete stock in id
        if (!this.stockIn.deleteStockInItemIds) {
          this.stockIn.deleteStockInItemIds = [];
        }
        this.stockIn.deleteStockInItemIds.push(stockInItemId);
      }
      this.$delete(this.stockIn.stockInItems, index);
    },

    showProductList() {
      this.showProductListDialog = true;
    },

    closeProductDialog(product) {
      this.showProductListDialog = false;
      this.selectedStockInItem = new StockInItem();

      this.selectedStockInItem.isNew = true;
      this.selectedStockInItem.id = this.generateId();

      this.selectedStockInItem.productId = product.id;
      this.selectedStockInItem.productCode = product.code;
      this.selectedStockInItem.productName = product.name;
      this.selectedStockInItem.productUnits = product.productUnits;
      // set default unit
      var j = 0;
      for (var i = 0; i < product.productUnits.length; i++) {
        if (product.productUnits[i].basicUnit == true) j = i;
      }
      this.selectedStockInItem.productUnitId = product.productUnits[j].id;
      this.selectedStockInItem.factorUnitName =
        product.productUnits[j].factorUnitName;
      this.selectedStockInItem.factor = product.productUnits[j].factor;

      if (this.poNoSelected) {
        if (
          this.selectedStockInItem.basicUnitCost > 0 &&
          this.selectedStockInItem.poExchangeRate > 0
        ) {
          this.selectedStockInItem.unitCost = parseFloat(
            this.selectedStockInItem.basicUnitCost *
              product.productUnits[j].factor *
              this.selectedStockInItem.poExchangeRate
          );
          this.selectedStockInItem.poUnitCost = parseFloat(
            this.selectedStockInItem.basicUnitCost *
              product.productUnits[j].factor
          );
        }
      } else {
        this.selectedStockInItem.unitCost = product.productUnits[j].unitCost;
        this.selectedStockInItem.poUnitCost = product.productUnits[j].unitCost;
      }

      this.selectedStockInItem.sellingPrice =
        product.productUnits[j].sellingPrice;
      this.selectedStockInItem.discountPercent = 0;
      this.selectedStockInItem.qty = 0;

      this.stockInItemDialog = true;
    },

    editDetail(stockInItem) {
      this.selectedStockInItem = JSON.parse(JSON.stringify(stockInItem));
      if (stockInItem.mfgDateInMilliSeconds) {
        this.selectedStockInItem.mfgDate = commonService.millisecondToDate(
          Number(stockInItem.mfgDateInMilliSeconds),
          "YYYY-MM-DD"
        );
      }
      if (stockInItem.expDateInMilliSeconds) {
        this.selectedStockInItem.expDate = commonService.millisecondToDate(
          Number(stockInItem.expDateInMilliSeconds),
          "YYYY-MM-DD"
        );
      }
      this.stockInItemDialog = true;
    },

    closePurchaseOrderDialog(purchaseOrder) {
      this.showPurchaseOrderDialog = false;

      if (purchaseOrder && purchaseOrder.id)
        this.prepareStockInItems(purchaseOrder);
    },
    prepareStockInItems(item) {
      this.poNoSelected = true;
      var stockIn = this.stockIn;
      stockIn.warehouseName = item.warehouseName;
      stockIn.poNo = item.issueNo;
      // Clear previous datas
      stockIn.stockInItems = [];

      let purchaseOrderItems = item.purchaseOrderItems;
      if (purchaseOrderItems) {
        purchaseOrderItems.forEach((item) => {
          if (item.basicQty > item.stockInQty) {
            let stockInItem = new StockInItem();
            stockInItem.isNew = true;
            stockInItem.id = this.generateId();
            stockInItem.productId = item.productId;
            stockInItem.productCode = item.productCode;
            stockInItem.productName = item.productName;
            stockInItem.factorUnitName = item.factorUnitName;
            stockInItem.factor = item.factor;
            stockInItem.productUnitId = item.productUnitId;
            stockInItem.productUnits = item.productUnits;
            stockInItem.poExchangeRate = item.currencyExchangeMMK;
            stockInItem.supplierId = item.supplierId;
            stockInItem.supplierName = item.supplierName;
            if (item.countryId) {
              stockInItem.countryId = item.countryId;
              stockInItem.countryName = item.countryName;
            } else {
              stockInItem.countryId = "";
              stockInItem.countryName = "";
            }

            stockInItem.basicUnitCost = item.basicUnitCost;
            stockInItem.unitCost = parseFloat(
              item.basicUnitCost * item.factor * item.currencyExchangeMMK
            );
            stockInItem.poUnitCost = parseFloat(
              item.basicUnitCost * item.factor
            );

            stockInItem.sellingPrice = item.sellingPrice;
            stockInItem.discountPercent = item.discountPercent;
            stockInItem.remark = item.remark;
            stockInItem.remainingQty =
              (item.basicQty - item.stockInQty) / item.factor;
            stockInItem.qty = stockInItem.remainingQty;
            stockIn.stockInItems.push(stockInItem);
          }
        });
      }
      this.showBin();
    },
    closeQCListDialog(qc) {
      this.showQCListDialog = false;
      if (qc && qc.id) {
        this.selectedStockInItem.qcNoSelected = true;
        this.selectedStockInItem.productUnitId = qc.productUnitId;
        this.selectedStockInItem.factorUnitName = qc.factorUnitName;
        this.selectedStockInItem.factor = qc.factor;
        this.selectedStockInItem.supplierId = qc.supplierId;
        this.selectedStockInItem.supplierName = qc.supplierName;
        if (qc.countryId) {
          this.selectedStockInItem.countryId = qc.countryId;
          this.selectedStockInItem.countryName = qc.countryName;
        } else {
          this.selectedStockInItem.countryId = "";
          this.selectedStockInItem.countryName = "";
        }
        this.selectedStockInItem.qcNo = qc.qcNo;
        this.selectedStockInItem.batchNo = qc.batchLotNo;
        if (qc.mfgDateInMilliSeconds) {
          this.selectedStockInItem.mfgDate = commonService.millisecondToDate(
            qc.mfgDateInMilliSeconds,
            "YYYY-MM-DD"
          );
        }
        if (qc.expDateInMilliSeconds) {
          this.selectedStockInItem.expDate = commonService.millisecondToDate(
            qc.expDateInMilliSeconds,
            "YYYY-MM-DD"
          );
        }
        this.selectedStockInItem.remainingQty =
          (qc.qcBasicQty - qc.stockInQty) / qc.factor;
        this.selectedStockInItem.qty = this.selectedStockInItem.remainingQty;
      }
    },
    changeWarehouse() {
      let warehouseName = this.stockIn.warehouseName;
      let warehouse = commonService.search(
        "name",
        warehouseName,
        this.activeWarehouseList
      );
      this.stockIn.warehouseId = warehouse.id;
    },
    trigger(barcode) {
      if (barcode) {
        this.barcodeLoading = true;
        let params = {
          barcode: barcode,
          isPurchase: true,
        };
        productService
          .getProductUnitByBarcode(params)
          .then((res) => {
            let productUnit = res.data;
            if (productUnit) {
              this.selectedStockInItem = new StockInItem();

              this.selectedStockInItem.isNew = true;
              this.selectedStockInItem.id = this.generateId();

              let product = productUnit.product;
              this.selectedStockInItem.productId = product.id;
              this.selectedStockInItem.productCode = product.code;
              this.selectedStockInItem.productName = product.name;
              this.selectedStockInItem.productUnitId = productUnit.id;
              this.selectedStockInItem.productUnits[0] = productUnit;
              this.selectedStockInItem.factorUnitName =
                productUnit.factorUnitName;
              this.selectedStockInItem.factor = productUnit.factor;
              this.selectedStockInItem.unitCost = productUnit.unitCost;
              this.selectedStockInItem.poUnitCost = productUnit.unitCost;
              this.selectedStockInItem.discountPercent = 0;
              this.selectedStockInItem.sellingPrice = productUnit.sellingPrice;

              this.stockInItemDialog = true;
            }
          })
          .catch((err) => {
            console.error(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.messageDialogBox = true;
            }
          })
          .finally(() => {
            this.scanBarcode = "";
            this.barcodeLoading = false;
          });
      }
    },
  },
};
</script>
